import { BaseService } from "./base.service";

class Service extends BaseService {

}

export const HerbBrandService = new Service('/herb-brand');